// extracted by mini-css-extract-plugin
module.exports = {"avatar":"common-ArtistAvatar__avatar--3ZdHk"};